var aimStyles = {
  '@global': {
    ':root': {
      '--aim-outline-color': '#005fcc',
      '&.aim-disabled': {
        '& *[tabindex]:focus': {
          outline: 'none'
        }
      },
      '&.aim-enabled': {
        '& *[tabindex]:focus': {
          outlineWidth: 2,
          outlineStyle: 'auto',
          outlineOffset: -1,
          outlineColor: 'var(--aim-outline-color)'
        }
      }
    }
  }
};
function withAimStyles() {
  function tabbed(e) {
    if (e.keyCode === 9) {
      document.documentElement.classList.remove('aim-disabled');
      document.documentElement.classList.add('aim-enabled');
      window.removeEventListener('keydown', tabbed);
      window.addEventListener('mousedown', clicked);
    }
  }
  function clicked() {
    var _document$getElementB;
    document.documentElement.classList.remove('aim-enabled');
    document.documentElement.classList.add('aim-disabled');
    (_document$getElementB = document.getElementById('aim-styles')) === null || _document$getElementB === undefined || _document$getElementB.remove();
    window.removeEventListener('mousedown', clicked);
    window.addEventListener('keydown', tabbed);
  }
  document.documentElement.classList.add('aim-disabled');
  window.addEventListener('keydown', tabbed);
}

export { aimStyles as default, withAimStyles };
//# sourceMappingURL=index.js.map
